/**
 * @class TableCell
 *
 * Contains data for table cell
 *
 * @property {string|React.ReactElement} data - data to be displayed in the table cell
 * @property {string} className - specific classes to be applied to this table cell
 * @property {undefined | string | number} key - unique key for table cell
 * @property {object} elementProps - other props to pass into table cell element (e.g. onClick, onScroll)
 */
export default class TableCell {
    /**
     *
     * @param {string|React.ReactElement} [data] - data to be displayed in the table cell
     * @param {string} [className] - specific classes to be applied to this table cell
     * @param {string | number} [key] - unique key for table cell
     * @param {object} [elementProps] - other props to pass into table cell element (e.g. onClick, onScroll)
     */
    constructor(data = "", className = "", key = undefined, elementProps = {}) {
        this._className = className;
        this._data = data;
        this._key = key;
        this._elementProps = elementProps;
    }

    /**
     * @returns {string}
     */
    get className() {
        return this._className;
    }

    /**
     * @returns {string | React.ReactElement}
     */
    get data() {
        return this._data;
    }

    /**
     * @returns {undefined | string | number}
     */
    get key() {
        return this._key;
    }

    /**
     * @returns {{}}
     */
    get elementProps() {
        return this._elementProps;
    }
}
